import { SymbologyValues } from 'app/store/appSettings/AppSettingsState.ts';
import { OrderVolumeProfileStreamRequest } from '../../api/OrderVolumeProfileStreamRequest.ts';
import { OrderVolumeProfileComponentState } from '../component/OrderVolumeProfileComponentState.ts';
import { Time, timeUtils } from '@instinet-analytics/core-lib';
import Order from 'communication/types/order/Order.ts';
import {
    initialOrderVolumeProfileConfiguration,
    OrderVolumeProfileConfiguration,
} from '../configuration/OrderVolumeProfileConfiguration.ts';

const { toDateTime } = timeUtils;

const toRequestUid = (
    symbol: string,
    startTime: string | null,
    endTime: string | null,
    qty: number,
    includeAuctions: boolean,
    regular: boolean,
    custom: boolean
) =>
    `OrderVolumeProfile-${symbol}-${startTime ?? 'null'}-${
        endTime ?? 'null'
    }-${qty}-${includeAuctions}-${regular}-${custom}`;

const timeToString = (time?: Time) =>
    time ? toDateTime(new Date(), time).toISOString() : null;

export const orderVolumeProfileRequestToStreamKey = (
    request: OrderVolumeProfileStreamRequest
) => {
    const {
        symbol,
        startTime,
        endTime,
        qty,
        includeAuctions,
        regular,
        custom,
    } = request;
    return toRequestUid(
        symbol,
        startTime,
        endTime,
        qty,
        includeAuctions,
        regular,
        custom
    );
};
export function buildOrderVolumeProfileRequest(
    symbol: string,
    symbology: SymbologyValues,
    order: Order,
    config: OrderVolumeProfileConfiguration = initialOrderVolumeProfileConfiguration,
    component?: OrderVolumeProfileComponentState
): OrderVolumeProfileStreamRequest {
    return {
        symbol,
        symbology,
        startTime: component?.startTime
            ? timeToString(component.startTime)
            : order.timeIn
            ? new Date(order.timeIn).toISOString()
            : null,
        endTime: timeToString(component?.endTime),
        qty: order.qty,
        includeAuctions: !!config?.includeAuctions,
        regular: !!config?.regular,
        custom: !!config?.custom,
    };
}

export function getStreamKey(
    symbol: string,
    symbology: SymbologyValues,
    order: Order,
    config: OrderVolumeProfileConfiguration = initialOrderVolumeProfileConfiguration,
    component?: OrderVolumeProfileComponentState
) {
    return orderVolumeProfileRequestToStreamKey(
        buildOrderVolumeProfileRequest(
            symbol,
            symbology,
            order,
            config,
            component
        )
    );
}
